<template>
  <div class="media-navigation">
    <template v-for="(item, index) in navigationList" :key="index">
      <div
        v-if="item !== undefined"
        class="navigation-item"
        :class="{'video': item.type === 3, 'three-D': item.type === 1, 'no-padding': item === 'divider' }"
        @click="changeNavigation(item)"
      >
        <div v-if="item === 'divider'" class="divider"></div>
        <div v-else class="img-container">
          <img :src="item.url" alt=""/>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'

const props = defineProps({
  dataSource: Array
})
const emit = defineEmits(['change'])

// 得到navigationList
const navigationList = ref([])
watch(() => props.dataSource, (arr) => {
  const oneList = arr.filter(item => item.type === 1)
  const twoList = arr.filter(item => item.type === 3)
  const threeList = arr.filter(item => item.type === 2)

  navigationList.value = [
    ...oneList,
    oneList.length > 0 ? 'divider' : undefined,
    ...twoList,
    oneList.length > 0 || twoList.length > 0 ? 'divider' : undefined,
    ...threeList
  ]
}, { immediate: true })

function changeNavigation (item) {
  emit('change', item)
}
</script>

<style lang="scss" scoped>
.media-navigation {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.navigation-item {
  padding: 0 36px;

  &.no-padding {
    padding: 0;
  }
}

.divider {
  height: 35px;
  width: 1px;
  background: #B5B5B6;
}

.img-container {
  position: relative;
  height: 60px;
  cursor: pointer;

  img {
    height: 100%;
    object-fit: contain;
  }
}

.video .img-container::after, .three-D .img-container::after {
  display: -webkit-box;
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);
  background-repeat: no-repeat;
  background-position: center;
}

.video .img-container::after {
  background-image: url("~@/assets/images/video.png");
}

.three-D .img-container::after {
  background-image: url("~@/assets/images/3d.png");
}
</style>
